/*
*
* File JS componente Block Gallery Grid
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import lightGallery from 'lightgallery';
import 'lightgallery/css/lightgallery-bundle.min.css';

//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-gallery-grid.scss';

//--------------------------------------------------------------------//

// JS SPECIFICO COMPONENTE
//--------------------------------------------------------------------//

let allBlockGallery = document.querySelectorAll('.block-gallery-grid');

const initLightgallery = () => {

    if(!allBlockGallery) return;

    allBlockGallery.forEach((el, i) => {

        lightGallery(el.querySelector('.lightgallery'), {
            thumbnail: false,
            animateThumb: false,
            showThumbByDefault: false,
            download: false,
            hideBarsDelay: 1000000000,
            autoplayControls: false,
            hash: false,
            escKey: true,
            keyPress: true,
            licenseKey: 'WQ63Z-598QW-NZ7D5-WPMTB'
        });

    });
}

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blockGalleryGrid = () => {
    initLightgallery();
}

export default blockGalleryGrid;

//--------------------------------------------------------------------//